import styled from 'styled-components';

export const Container = styled.div.attrs(() => ({
  className: 'container',
}))`
  width: 100%;
  padding: 0 20px;
  max-width: 1490px;
  margin: 0 auto;

  @media (max-width: 767px) {
    .product-layout .main & {
      padding: 0 8px;
      background: var(--white);
    }
  }
`;

export const ContainerContent = styled.div`
  width: 100%;
  padding: 0 20px;
  max-width: 1472px;
  margin: 0 auto;

  &.self {
    max-width: 1490px;
  }

  @media (max-width: 1490px) {
    max-width: 1182px;
  }

  @media (max-width: 1200px) {
    max-width: 892px;
  }

  @media (max-width: 910px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    min-height: 800px;
  }
`;
